<template>
    <span class="contents">
        <slot :is-offer="isOffer" :discount="discount"></slot>
    </span>
</template>

<script>
export default {
    name: "ProductPriceViewer",
    props: {
        price: { type: Number, required: true, default: 0 },
        priceOffer: { type: Number, required: true, default: 0 }
    },
    data: () => ({
        isOffer: false,
        discount: 0
    }),
    created() {
        this.isOffer = this.priceOffer > 0 && this.priceOffer < this.price;
        this.discount = this.isOffer
            ? Number(
                  (100 * (this.price - this.priceOffer)) / this.price
              ).toFixed(1)
            : 0;
    }
};
</script>
